// extracted by mini-css-extract-plugin
module.exports = {"highlightedLink":"styles_highlightedLink__3QfeW","highlight":"styles_highlight__1d1j6","active":"styles_active__3PxBp"};